// ============================================================
// THE TICKER - the rolled-up log as its newest line (plan map-display, E).
//
// The newest line the viewer would see in the log the ticker stands in for:
// lanes they switched off are skipped (engine/log/lanes), and a line reads as
// its summary when it has a structured twin (engine/impacts), else its first
// line of text.
//
// Pure. Zero React dependency.
// ============================================================
import { structuredOf } from '../impacts';
import { laneOf, type Lane } from './lanes';
import type { NarrativeEntry } from '../../types';

export function tickerLine(entries: readonly NarrativeEntry[] | undefined, hidden: readonly Lane[]): string {
  const all = entries ?? [];
  // From the newest back: the first one looked at is usually the line.
  for (let i = all.length - 1; i >= 0; i--) {
    const entry = all[i];
    if (hidden.includes(laneOf({ kind: 'narrative', entry, ts: entry.timestamp }))) continue;
    return (structuredOf(entry)?.summary || entry.text || '').split('\n')[0];
  }
  return '';
}
